<template>
    <div class="status-change">
        <span>
            {{ action.label }}
            <ui-tooltip open-on="click">{{ action.chronology_date | humanDayTime }}</ui-tooltip>
        </span>
    </div>
</template>

<script>

import Filters from '../../filters'

export default {
    filters: Filters,
    props: {
        action: {
            type: Object,
            required: true
        }
    }
}
</script>

<style scoped lang="scss">
    .status-change {
        text-align: center;

        span {
            font-size: .8rem;
            padding: .1rem .75rem;
            border-radius: 10px;
            font-weight: bold;
            margin-bottom: 1rem;
            display: inline-block;
            text-transform: uppercase;
            background: #999;
            color: #fff;
            cursor: pointer;
        }
    }
</style>